import Button from "components/Button";
import FollowedCaseCards from "components/FollowedCaseCards";
import { getCaseDbData } from "helpers/case-helpers";

import { useUser } from "@auth0/nextjs-auth0/client";
import { useState, useEffect, useCallback } from "react";

import SvgEmptyUpdates from "assets/svgs/empty-updates.svg";

export default function FollowedCases({ outsetaUserCaseList }) {
  const [followedCases, setFollowedCases] = useState([]);
  const [casesLoading, setCasesLoading] = useState(false);
  const { isLoading } = useUser();

  const getCases = useCallback(
    async () => {
      setCasesLoading(true);
      const caseSlugArray = outsetaUserCaseList
        ? outsetaUserCaseList.split(",")
        : [];

      const promises = [];
      for (const slug of caseSlugArray) {
        promises.push(getCaseDbData(slug));
      }

      const resultsArray = await Promise.all(promises);

      setCasesLoading(false);
      const caseArray = resultsArray.filter((r) => r.result !== undefined);

      setFollowedCases(caseArray.map((r) => r.result));
    }, [outsetaUserCaseList]);

  useEffect(() => {
    if (outsetaUserCaseList !== "") {
      getCases();
    }
  }, [outsetaUserCaseList, getCases]);

  return (
    <>
      <h2 className="font-semibold text-lg">Cases You Follow</h2>
      {isLoading || casesLoading ? (
        <>
          <article className="bg-white p-8 text-center">
            <strong className="block mb-4 text-2xl">
              Loading your cases...
            </strong>
            <SvgEmptyUpdates className="mb-6 mx-auto max-w-full" width="510" />
          </article>
        </>
      ) : followedCases && followedCases.length > 0 ? (
        <section className="pt-4 md:gap-4 md:grid md:grid-cols-2">
          <FollowedCaseCards cases={followedCases} />
        </section>
      ) : (
        <article className="bg-white p-8 text-center">
          <SvgEmptyUpdates className="mb-6 mx-auto max-w-full" width="510" />
          <p className="mb-6 text-lg">
            <strong className="block mb-4 text-2xl">
              You aren&apos;t following any cases
            </strong>
            Follow a case to see any updates to the case listed here.
          </p>
          <Button
            className="text-sm"
            href={"/cases"}
            emphasis="primary"
            height="32"
          >
            View Cases
          </Button>
        </article>
      )}
    </>
  );
}
